document.addEventListener('DOMContentLoaded', () => {

  // --- Subcategory Menu Logic ---
  const container = document.querySelector('.subcategory-list');
  const links = document.querySelectorAll('.subcategory-item-link');
  const wrapper = container?.closest('[data-underline]');
  const hasUnderline =
    wrapper?.dataset.underline === 'true';
  const underline =
    hasUnderline
      ? wrapper.querySelector('.subcategory-underline')
      : null;
  const arrowLeft = document.querySelector('.subcategory-arrow-left');
  const arrowRight = document.querySelector('.subcategory-arrow-right');

  if (container && links.length) {
    function updateArrows() {
      window.requestAnimationFrame(() => {
        const scrollLeft = Math.ceil(container.scrollLeft);
        const maxScroll = container.scrollWidth - container.clientWidth;
        if (arrowLeft) arrowLeft.style.display = scrollLeft > 5 ? 'flex' : 'none';
        if (arrowRight) arrowRight.style.display = scrollLeft < maxScroll - 5 ? 'flex' : 'none';
      });
    }

    [arrowLeft, arrowRight].forEach(arrow => {
      if (!arrow) return;
      arrow.addEventListener('click', () => {
        const direction = arrow.classList.contains('subcategory-arrow-left') ? -1 : 1;
        container.scrollBy({ left: direction * 200, behavior: 'smooth' });
      });
    });

    container.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    function getTargetScroll(el) {
      return el.offsetLeft - (container.clientWidth / 2) + (el.offsetWidth / 2);
    }

    function setUnderline(el, instant = false) {
      if (!underline) return;
      underline.style.transition = instant ? 'none' : 'left 0.3s ease, width 0.3s ease, opacity 0.3s ease';
      underline.style.left = el.offsetLeft + 'px';
      underline.style.width = el.offsetWidth + 'px';
      underline.style.opacity = '1';
      if (instant) underline.offsetHeight;
    }

    const current = container.querySelector('.subcategory-item-link.current');
    if (current && underline) {
      setUnderline(current, true);
      const target = getTargetScroll(current);
      if (Math.abs(container.scrollLeft - target) > 2) {
        container.scrollLeft = target;
      }
    }

    updateArrows();

    links.forEach((link) => {
      link.addEventListener('click', function (e) {
        if (this.hostname !== window.location.hostname || this.classList.contains('current')) return;
        e.preventDefault();

        sessionStorage.setItem('subcategory-active-text', this.textContent.trim());
        if (underline) {
            setUnderline(this);
        }
        container.scrollTo({ left: getTargetScroll(this), behavior: 'smooth' });

        links.forEach(l => l.classList.remove('current'));
        
        this.classList.add('current');

        setTimeout(() => { window.location.href = this.href; }, 300);
      });
    });

    sessionStorage.removeItem('subcategory-active-text');
  }

});
